<template>
  <TextInputDialog ref="textInput"></TextInputDialog>
  <ConfirmationDialog ref="confirmation"></ConfirmationDialog>
  <CreateAccount ref="createAccount"></CreateAccount>
  <Info ref="info"></Info>
</template>

<script setup>
import globalContext, {registerSingleton} from "@/services/GlobalContext";
import {onMounted, ref, getCurrentInstance, useTemplateRef} from "vue";
import TextInputDialog from "@/components/dialogs/variants/TextInputDialog.vue";
import ConfirmationDialog from "@/components/dialogs/variants/ConfirmationDialog.vue";
import CreateAccount from "@/components/dialogs/variants/CreateAccount.vue";
import Info from "@/components/dialogs/variants/Info.vue";
const dialogManager = globalContext['DialogManager'];

const textInput = useTemplateRef("textInput");
const confirmation = useTemplateRef("confirmation");
const createAccount = useTemplateRef("createAccount");
const info = useTemplateRef("info");

onMounted(() => {
  let instance = getCurrentInstance();
  dialogManager.setMountpointInstance(instance);
});

defineExpose({
  textInput,
  confirmation,
  info,
  createAccount
})


</script>



<style scoped>

</style>